export default "__VITE_ASSET__Co$Pcl5v__"